import { render, staticRenderFns } from "./candidate-profile.vue?vue&type=template&id=815738da&lang=html&"
import script from "./candidate-profile.vue?vue&type=script&lang=js&"
export * from "./candidate-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports